var moment = require('moment');
import * as $ from 'jquery';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CustomDateFormat {
    constructor() {

    }

    static NewDate :any;
    static DateFormateList = {
        "ddmmyyyy": "ddmmyyyy", 
        "yyyyddmm": "yyyyddmm",
        "yyyymmdd": "yyyymmdd", 
        "dd.mm.yyyy": "dd.mm.yyyy",
        "dd/mm/yyyy": "dd/mm/yyyy", 
        "mm/dd/yyyy": "mm/dd/yyyy", 
        "dd-mmm-yy": "dd-mmm-yy", 
        "dd-mmm-yyyy": "dd-mmm-yyyy", 
        "mm/yy": "mm/yy", 
        "mm/yyyy": "mm/yyyy",
        "mm-yy": "mm-yy", 
        "mmyyyy": "mmyyyy", 
        "mmm-yy": "mmm-yy",
        "dd-mm-yyyy": "dd-mm-yyyy",
        "yyyy-mm": "yyyy-mm",
        "YYYY-MM-DD": "YYYY-MM-DD"
    };

    static GetFormattedDate(Value: any, FormatType){
        this.NewDate = null;
        var newVal = '';
        if(FormatType == 'ddmmyyyy') {
            newVal =  Value.substr(2, 2) + '-' + Value.substr(0, 2) + '-' + Value.substr(4, 4);            
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        } else if (FormatType == 'yyyyddmm') {
            newVal = Value.substr(6, 2) + '-' + Value.substr(4, 2) + '-' + Value.substr(0, 4);
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        } else if(FormatType == 'yyyymmdd') {
            newVal = Value.substr(4, 2) + '-' + Value.substr(6, 2) + '-' + Value.substr(0, 4);
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        } else if(FormatType == 'dd.mm.yyyy' || FormatType == 'dd/mm/yyyy') {
            Value = Value.replace(/\./g,'/');
            Value = Value.split('/');
            newVal = Value[1] + '-' + Value[0] + '-' + Value[2];
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        } else if(FormatType == 'mm/dd/yyyy') {
            this.NewDate =  moment(new Date(Value)).format('YYYY-MM-DD');

        }else if(FormatType == 'dd-mmm-yyyy' || FormatType == 'dd-mmm-yy') {
            Value = Value.split('-');
            newVal = Value[1] + '-' + Value[0] + '-' + Value[2];
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        }else if(FormatType == 'mm/yy' || FormatType == 'mm/yyyy' || FormatType == 'mm-yy') {
            Value = Value.replace(/\-/g,'/');
            Value = Value.split('/');
            newVal = Value[0] + '-01-' + Value[1];
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        }else if(FormatType == 'mmyyyy') {
            newVal = Value.substr(0, 2) + '-01-' + Value.substr(2, Value.length);
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        }else if(FormatType == 'mmm-yy') {
            Value = Value.split('-');
            newVal = Value[0] + '-01-' + Value[1];
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        }else if(FormatType == 'dd-mm-yyyy' || FormatType == 'dd-mm-yyyy') {
            Value = Value.split('-');
            newVal = Value[1] + '-' + Value[0] + '-' + Value[2];
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        }
        else if(FormatType == 'yyyy-mm') {
            Value = Value.split('-');
            newVal = Value[1] + '-01-' + Value[0];
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        }
        else if(FormatType == 'YYYY-MM-DD') {
            Value = Value.split('-');
            newVal = Value[1] + '-' + Value[2] + '-' + Value[0];
            this.NewDate =  moment(new Date(newVal)).format('YYYY-MM-DD');

        }
        return this.NewDate;
    }

    GetCustomDateFormat(self, datePipe){
      //  debugger
        var val = self.value;
        if(!val)
            return;
      //   console.log(' val : ', val);
        val = val.replace(/\//g,'-');
        var dateList = val.split('-');
        var date = '';
        //var CurrDay = datePipe.transform(new Date(), 'dd');
        var CurrMonth = datePipe.transform(new Date(), 'MMM');
        var CurrYear = datePipe.transform(new Date(), 'yyyy');
        var Month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        if(dateList.length > 0){
            date = dateList[0];
        }
        if(dateList.length > 1){
            if(parseInt(dateList[1]) > 0){
                date = date + '-' + ((dateList[1] * 1) <= 12? Month[(dateList[1] * 1)-1]: CurrMonth);
            } else {
                date = date + '-' + dateList[1];
            }
        }

        date = date + '-' + (dateList.length > 2 && dateList[2]? dateList[2]: CurrYear);
        //CurrYear.substring(0, (CurrYear.length - dateList[2].length)) + dateList[2]
        
        if(!((new Date(date)).toDateString() == 'Invalid Date')){
            //$('#'+event.target.id).val(moment(new Date(date)).format('YYYY-MM-DD'));
            //$('#'+event.target.id).val(datePipe.transform(new Date(date), 'dd-MMM-yyyy'));
            $(self).val(datePipe.transform(new Date(date), 'dd-MMM-yyyy'));
        }
    }
}